:host,
.ch-flexible-layout-render-slot {
  display: contents;
}